module.exports = __webpack_public_path__ + "static/media/uxui_small_banner.db954504.jpg";